import React from 'react';
import './PolicyTheocracyDescription.css';
import DescriptionValueWithIcon from "../../DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  POLICY_THEOCRACY_MELEE_BONUS,
  POLICY_THEOCRACY_TEMPLE_WIN_POINTS_INCOME_BONUS
} from "../../../../configs/policy/theocracy";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";

const PolicyTheocracyDescription = () => {
  // const templeFirst = <img
  //   className={'policy-description-icon-building policy-description-icon-building-margin-right'}
  //   src={'/img/hexes/special buildings/temple.17c08b3d.png'}
  //   alt={'Храм'}
  //   title={'Храм'}
  // />;
  //
  // const discountElement = <img
  //   className={'policy-description-icon policy-description-icon-margin-right-left'}
  //   src={'/img/icons/percent white.png'}
  //   alt={'Скидка'}
  //   title={'Скидка'}
  // />;
  //
  // const buildingDiscount =
  //   <CoinsStat
  //     text={POLICY_THEOCRACY_BUILDING_DISCOUNT_TEMPLE}
  //     noShrinkOnMobile={true}
  //     isDarkColor={true}
  //     className={'policy-description-icon-margin-left'}
  //   />;

  const temple = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/temple.17c08b3d.png'}
    alt={'Храм'}
    title={'Храм'}
  />;

  const winPoints = <WinPointsStat
    text={`+${POLICY_THEOCRACY_TEMPLE_WIN_POINTS_INCOME_BONUS}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />

  const city = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/icons/city.42008716.png'}
    alt={'Город'}
    title={'Город'}
  />;

  const damageBonus = <span className={'text-war'}>
    {`+${POLICY_THEOCRACY_MELEE_BONUS}`}
  </span>;

  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  return (
    <>
      {/*<div className={'policy-description_line'}>*/}
      {/*  {templeFirst} дешевле {discountElement} на {buildingDiscount}.*/}
      {/*</div>*/}
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        Доход {temple} {winPoints}.
      </div>
      <div className={'policy-description_line policy-description_line-margin-top-paragraph'}>
        В {city} с {temple} {unit} имеет {damageBonusValueAndIcon}.
      </div>
    </>
  );
};

export default PolicyTheocracyDescription;
